import env from "../env.config";

export const fetchData = async (
  url: string,
  APIVersion: string = env.apiV1
) => {
  return await fetch(`${env.baseUrl}${url}`, {
    headers: {
      version: APIVersion,
    },
  });
};
